module.exports = __webpack_public_path__ + "static/media/media5.b69591e0.jpeg";